/**
 * Generated runtime TestId mirror for frontend/src/pages/AccessProfileDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccessProfileDetailTestIds = {
  accessProfileDetailPage: "access-profile-detail-page",
  apFunctionGroupsCard: "ap-function-groups-card",
  btnActivate: "btn-activate",
  btnAddEnforcementObject: "btn-add-enforcement-object",
  btnDeleteProfile: "btn-delete-profile",
  btnDeprecate: "btn-deprecate",
  btnEdit: "btn-edit",
  btnRetryFg: "btn-retry-fg",
  btnSelectAllEnforcementObjects: "btn-select-all-enforcement-objects",
  cardProfileDetails: "card-profile-details",
  cardTitleEnforcementObjects: "card-title-enforcement-objects",
  colActions: "col-actions",
  colEnforcementObject: "col-enforcement-object",
  colEoName: "col-eo-name",
  colEoSystem: "col-eo-system",
  colEoType: "col-eo-type",
  colFgName: "col-fg-name",
  colFgType: "col-fg-type",
  colOperation: "col-operation",
  colSelect: "col-select",
  colSystem: "col-system",
  fgEmptyState: "fg-empty-state",
  linkResource: "link-resource",
  profileCode: "profile-code",
  profileDescription: "profile-description",
  sectionAttributes: "section-attributes",
  selectOperation: "select-operation",
  btnDeleteBinding: (binding_id: string) => `btn-delete-binding-${binding_id}`,
  btnDeleteBindingPrefix: () => "btn-delete-binding-" as TestIdPrefix,
  enforcementType: (binding_id: string) => `enforcement-type-${binding_id}`,
  enforcementTypePrefix: () => "enforcement-type-" as TestIdPrefix,
  fgRow: (fg_functionGroup_id: string) => `fg-row-${fg_functionGroup_id}`,
  fgRowPrefix: () => "fg-row-" as TestIdPrefix,
  linkEnforcementObject: (binding_id: string) => `link-enforcement-object-${binding_id}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkFg: (fg_functionGroup_id: string) => `link-fg-${fg_functionGroup_id}`,
  linkFgPrefix: () => "link-fg-" as TestIdPrefix,
  linkSystem: (binding_id: string) => `link-system-${binding_id}`,
  linkSystemPrefix: () => "link-system-" as TestIdPrefix
} as const;
